// @flow
import React from "react";
import { type Moment, type MomentInput } from "moment";
import ReactDatetime from "react-datetime";
import StyleWrapper from "./StyleWrapper";
import { TextInput } from "../TextInput";

type Props = {
  label?: string,
  placeholder?: string,
  value: MomentInput | null,
  today: Moment,
  onChange?: (Moment | string) => void, // Moment instance if valid date, string if not
  viewMode?: "years" | "months" | "days",
};

export const DatePicker = ({
  label,
  placeholder,
  value,
  onChange,
  viewMode,
  today,
}: Props) => (
  <>
    <StyleWrapper />
    <ReactDatetime
      value={value}
      onChange={onChange}
      closeOnSelect
      timeFormat={false}
      dateFormat="DD/MM/YYYY"
      viewMode={viewMode}
      viewDate={today}
      renderInput={(props) => (
        <TextInput
          {...props}
          label={label}
          placeholder={placeholder}
          readOnly
        />
      )}
    />
  </>
);
